import { Spin } from 'antd';
import { Loading3QuartersOutlined } from '@ant-design/icons';


const CustomSpin = ({size=24})=>{
    const customIcon = <Loading3QuartersOutlined  style={{ fontSize: size, color:'#adb5bd' }} spin />;
    return(<Spin indicator={customIcon} />)
}

export default CustomSpin
